<div class="flex flex-col gap-2 rounded bg-pl-gray-100 p-6 shadow-md">
  <div class="flex gap-4 text-lg">
    <ng-container *ngIf="!showForm()">
      <div class="flex grow flex-col gap-4">
        <p class="font-bold">{{ status.first_name }} {{ status.last_name }}</p>
        <p *ngIf="!status.submitted" class="">
          {{ status.email }}
        </p>
      </div>

      <div *ngIf="!!status.submitted" class="flex items-center gap-2">
        <pl-icon [name]="PlIcon.tick" class="h-6 w-6 text-pl-orange-800" />
        <p class="text-sm font-bold uppercase text-pl-orange-800">
          {{ 'profile.friends_survey_status.completed' | translate }}
        </p>
      </div>

      <div *ngIf="!status.submitted" class="flex w-36 flex-col gap-4">
        <pl-button
          [variant]="ButtonVariant.lightGray"
          [padding]="ButtonPadding.small"
          (click)="showFormToEditFriendDetails()"
        >
          <div class="flex items-center gap-2">
            <pl-icon [name]="PlIcon.pen_to_square" class="h-5 w-5" />
            <span class="font-bold">{{ 'utils.edit' | translate }}</span>
          </div>
        </pl-button>
        <pl-button
          [variant]="ButtonVariant.lightGray"
          [padding]="ButtonPadding.small"
          [isDisabled]="nudgeSent()"
          (click)="nudge()"
        >
          <div class="flex items-center gap-2">
            <pl-icon *ngIf="nudgeSent()" [name]="PlIcon.tick" class="h-6 w-6" />
            <span class="font-bold">{{
              (nudgeSent() ? 'profile.friends_survey_status.nudged' : 'profile.friends_survey_status.nudge') | translate
            }}</span>
          </div>
        </pl-button>
      </div>
    </ng-container>

    <form
      #myForm="ngForm"
      *ngIf="showForm()"
      [formGroup]="form"
      (ngSubmit)="saveFriendsDetails()"
      class="flex grow flex-col gap-4"
    >
      <pl-input
        [formControlName]="FormControlName.name"
        [isFormSubmitted]="myForm.submitted"
        [label]="'utils.name' | translate"
      />
      <pl-input
        [formControlName]="FormControlName.email"
        [isFormSubmitted]="myForm.submitted"
        [label]="'utils.email' | translate"
      />
      <div class="flex max-w-[300px] gap-4">
        <pl-button
          [padding]="ButtonPadding.small"
          [variant]="ButtonVariant.lightGray"
          (click)="discardChangeEditFriendDetails()"
        >
          {{ 'utils.cancel' | translate }}
        </pl-button>
        <pl-button [variant]="ButtonVariant.orange" [padding]="ButtonPadding.small" [type]="PlButtonType.submit">
          {{ 'utils.save' | translate }}
        </pl-button>
      </div>
    </form>
  </div>

  <p *ngIf="error()" class="text-xs text-pl-error">
    {{ error() }}
  </p>
</div>
